export class PaymentActionFilter {
  RemittanceInformation: string;
  CompanyId?: number;

  constructor(companyId?: number) {
    this.RemittanceInformation = null;
    this.CompanyId = null;

    if (companyId) {
      this.CompanyId = companyId;
    }
  }
}
